export default __webpack_public_path__ + "d1e465b63a8dba7aa87dca54e6073292.png";